import { graphql } from "react-relay";

export const autopilotStatusFinishedFragments = {
  org: graphql`
    fragment AutopilotStatusFinished_org on Org {
      nextDefragTime {
        ... on DefragTime {
          millis
        }
      }
      tailoredDefragCardSummary {
        __typename
        ... on TailoredDefragCardSummary {
          yourEventMoves {
            event {
              title
            }
          }
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }
    }
  `,
};
